// extracted by mini-css-extract-plugin
export default {"zoom":"ZoomHandler_zoom__01hS- font-sm-medium","zoom__btn":"ZoomHandler_zoom__btn__3YQ71"};